import React, { memo } from 'react'

import { Row, Column } from '@ublique/components/Grid'
import TextInput from '@ublique/components/TextInput'
import Autocomplete from '@ublique/components/Autocomplete'

import { isInvalidByField } from '../utils/form'
import { getTimezones } from '../utils/options'
import { HOURS, MINUTES, TIMEZONE } from '../constants'
import LabelWithInfo from './LabelWithInfo'

const JobTime = ({
  t,
  disabled,
  minutes,
  hours,
  timezone,
  setFieldValue,
  submitted,
  getHandleFieldChange,
  editingValues
}) => {
  const timezones = getTimezones()

  return (
    <Row className='cron-expression-fields'>
      <Column sm={2} md={2} lg={3}>
        <TextInput
          placeholder='mm'
          labelText={
            <LabelWithInfo
              label={t('Crontab.MINUTES')}
              message={t('Crontab.Fields.MINUTES_TOOLTIP')}
              alignment='start'
            />
          }
          value={minutes}
          onChange={getHandleFieldChange(MINUTES)}
          invalid={isInvalidByField.minutes({
            value: minutes,
            disabled,
            isEditing: editingValues[MINUTES]
          })}
          invalidText={t('Crontab.MINUTES_INVALID')}
          type='number'
          min={0}
          max={59}
          disabled={disabled}
        />
      </Column>
      <Column sm={2} md={2} lg={3}>
        <TextInput
          placeholder='hh'
          labelText={
            <LabelWithInfo
              label={t('Crontab.HOURS')}
              message={t('Crontab.Fields.HOURS_TOOLTIP')}
              alignment='start'
            />
          }
          value={hours}
          onChange={getHandleFieldChange(HOURS)}
          invalid={isInvalidByField.hours({
            value: hours,
            disabled,
            isEditing: editingValues[HOURS]
          })}
          invalidText={t('Crontab.HOURS_INVALID')}
          type='number'
          min={0}
          max={23}
          disabled={disabled}
        />
      </Column>
      <Column sm={4} md={4} lg={6}>
        <Autocomplete
          id='timezone'
          valueKey='value'
          labelKey='label'
          searchKey='label'
          items={timezones}
          defaultValue={
            timezones && timezones.find(({ value }) => value === timezone)
          }
          labelText={
            <LabelWithInfo
              label={t('Crontab.TIMEZONE')}
              message={t('Crontab.Fields.TIMEZONE_TOOLTIP')}
            />
          }
          placeholder={t('Crontab.TIMEZONE')}
          invalidText={t('Crontab.TIMEZONE_REQUIRED')}
          onChange={(value) => setFieldValue(TIMEZONE, value)}
          invalid={isInvalidByField.timezone({
            value: timezone,
            submitted,
            disabled
          })}
          disabled={disabled}
        />
      </Column>
    </Row>
  )
}

export default memo(JobTime)
